import Filial from '@/spa/filial/FilialCadastro';

export default {
  path: 'filial',
  name: 'filial',
  component: Filial,
};
